export function sat(slttString: string, avttString: string) {
    return slttString
}